<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="toc"><a id="page_vii"></a><a href="#/xhtml/08_Preface">Preface</a></p>
<p class="toc"><a href="#/xhtml/09_Acknowledgement">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/11_Introduction">Introduction: The Pragmatic Maxim</a></p>
<p class="toc1"><a href="#/xhtml/12_Chapter01">1    Peirce’s Early Presentation of the Maxim</a></p>
<p class="toc1"><a href="#/xhtml/13_Chapter02">2    James’s Presentation of the Maxim</a></p>
<p class="toc1"><span href="#/xhtml/14_Chapter03" title="Link target outside of Sample">3    Peirce’s Later Versions of the Maxim</span></p>
<p class="toc1"><span href="#/xhtml/15_Chapter04" title="Link target outside of Sample">4    A Composite Sketch of the Maxim</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter05" title="Link target outside of Sample">5    Empiricism versus Pragmatism</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter06" title="Link target outside of Sample">6    Measurement and the Observer Effect</span></p>
<p class="toc1"><span href="#/xhtml/18_Chapter07" title="Link target outside of Sample">7    Perception and Action</span></p>
<p class="toc1"><span href="#/xhtml/19_Chapter08" title="Link target outside of Sample">8    Addams and the Settlement Movement</span></p>
<p class="toc1"><span href="#/xhtml/20_Chapter09" title="Link target outside of Sample">9    Truth, Justice, and the American Pragmatist Way</span></p>
<p class="toc1"><span href="#/xhtml/21_Chapter10" title="Link target outside of Sample">10  Twelve Misconceptions of Pragmatism</span></p>
<p class="toc"><span href="#/xhtml/22_Conclusion" title="Link target outside of Sample">Conclusion: Belief and Meaning</span></p>
<p class="toc"><span href="#/xhtml/23_Appendix01" title="Link target outside of Sample">Appendices</span></p>
<p class="toc"><span href="#/xhtml/25_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/xhtml/26_Index01" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?3ffcc93a